import { useQuery } from '@do/seashell/graphql';
import { Session, Session_sessionData } from '../generated-types/Session';
import { GET_SESSION } from '../queries/queries';

const useSession = (): Session_sessionData => {
  const { data: { sessionData } = {} } = useQuery<Session>(GET_SESSION);

  return {
    session_id: sessionData?.session_id || null
  };
};

export default useSession;
